<script setup lang="ts">
defineProps<{
  type: string
}>()
</script>

<template>
  <svg class="sock-tool-icon" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <template v-if="type === 'cuff'">
      <rect class="fill" x="7" y="5" width="18" height="8" rx="1"/>
      <path class="line" d="M9 6v6M13 6v6M17 6v6M21 6v6M8 14c2 4 3 8 1 13M24 14c-1 4-1 8 1 13"/>
      <path class="line strong" d="M9 27h16"/>
    </template>
    <template v-else-if="type === 'heel'">
      <path class="fill" d="M8 10h14v7c0 5-4 9-10 9H8Z"/>
      <path class="line strong" d="M8 17c6 1 10 4 12 8"/>
    </template>
    <template v-else-if="type === 'toe'">
      <path class="fill" d="M7 11h13c4 0 7 3 7 7s-3 7-7 7H7Z"/>
      <path class="line strong" d="M19 12c3 4 3 8 0 12"/>
    </template>
    <template v-else-if="type === 'mesh'">
      <rect class="fill" x="7" y="9" width="18" height="14" rx="2"/>
      <path class="line" d="M8 10l16 12M13 9l12 9M7 16l10 8M24 10L8 22M19 9L7 18M25 16l-10 8"/>
    </template>
    <template v-else-if="type === 'compression_band'">
      <path class="fill" d="M8 8h16v16H8Z"/>
      <path class="line strong" d="M8 12h16M8 16h16M8 20h16"/>
    </template>
    <template v-else-if="type === 'elastic_band'">
      <path class="line strong" d="M7 10c3-4 6 4 9 0s6 4 9 0M7 17c3-4 6 4 9 0s6 4 9 0M7 24c3-4 6 4 9 0s6 4 9 0"/>
    </template>
    <template v-else-if="type === 'stripe'">
      <rect class="fill" x="7" y="8" width="18" height="16" rx="2"/>
      <path class="line strong" d="M10 11h12M10 16h12M10 21h12"/>
    </template>
    <template v-else-if="type === 'logo'">
      <path class="fill" d="M16 6l10 10-10 10L6 16Z"/>
      <path class="line strong" d="M12 16h8"/>
    </template>
    <template v-else-if="type === 'jacquard'">
      <rect class="fill" x="7" y="7" width="18" height="18" rx="2"/>
      <path class="line" d="M11 11h4v4h-4ZM17 11h4v4h-4ZM11 17h4v4h-4ZM17 17h4v4h-4Z"/>
    </template>
    <template v-else-if="type === 'lace_trim'">
      <path class="line strong" d="M5 10h22"/>
      <path class="line" d="M5 12q3 8 6 0t6 0t6 0t4 0"/>
      <circle class="dot" cx="9" cy="18" r="1.5"/>
      <circle class="dot" cx="16" cy="18" r="1.5"/>
      <circle class="dot" cx="23" cy="18" r="1.5"/>
    </template>
    <template v-else-if="type === 'picot_edge'">
      <path class="line strong" d="M5 12h22"/>
      <path class="line" d="M6 13l3 6 3-6 3 6 3-6 3 6 3-6 3 6"/>
    </template>
    <template v-else-if="type === 'scalloped_edge'">
      <path class="line strong" d="M5 12h22"/>
      <path class="line" d="M5 14q3 8 6 0t6 0t6 0t4 0"/>
    </template>
    <template v-else-if="type === 'double_layered_ruffle'">
      <path class="fill" d="M5 11h22v8q-3 5-6 0t-6 0t-6 0t-4 0Z"/>
      <path class="line" d="M5 14q3 7 6 0t6 0t6 0t4 0M5 19q3 6 6 0t6 0t6 0t4 0"/>
    </template>
    <template v-else-if="type === 'fabric_loop_trim'">
      <path class="line strong" d="M6 10h20"/>
      <path class="fill" d="M12 11c0 11 8 11 8 0"/>
      <path class="line" d="M12 11c0 8 8 8 8 0"/>
    </template>
    <template v-else-if="type === 'folded_over_cuff'">
      <rect class="fill" x="7" y="7" width="18" height="15" rx="1"/>
      <path class="line strong" d="M7 14h18M10 8v5M14 8v5M18 8v5M22 8v5"/>
      <path class="line" d="M10 22c2 3 10 3 12 0"/>
    </template>
    <template v-else-if="type === 'bow_detail'">
      <path class="fill" d="M16 16C8 8 5 11 6 16s4 8 10 0c6 8 9 5 10 0s-2-8-10 0Z"/>
      <circle class="dot" cx="16" cy="16" r="2"/>
    </template>
    <template v-else-if="type === 'embroidery_motif'">
      <path class="line strong" d="M16 24V9"/>
      <path class="fill" d="M16 12c-6-6-10 0 0 4 10-4 6-10 0-4Z"/>
      <circle class="dot" cx="11" cy="20" r="2"/>
      <circle class="dot" cx="21" cy="20" r="2"/>
    </template>
    <template v-else-if="type === 'contrast_piping'">
      <path class="line strong" d="M5 16h22"/>
      <path class="line" d="M5 11h22M5 21h22"/>
    </template>
    <template v-else-if="type === 'applique_patch'">
      <rect class="fill" x="8" y="7" width="16" height="18" rx="3"/>
      <path class="line" d="M11 10h10v12H11Z"/>
      <path class="line stitch" d="M9 13h14M9 19h14"/>
    </template>
    <template v-else-if="type === 'bead_trim'">
      <path class="line" d="M5 12h22"/>
      <circle class="bead" cx="8" cy="18" r="2.2"/>
      <circle class="bead" cx="14" cy="18" r="2.2"/>
      <circle class="bead" cx="20" cy="18" r="2.2"/>
      <circle class="bead" cx="26" cy="18" r="2.2"/>
    </template>
    <template v-else-if="type === 'silicone_grip_dots'">
      <path class="fill" d="M7 11h18v10H7Z"/>
      <circle class="dot" cx="11" cy="14" r="1.7"/>
      <circle class="dot" cx="17" cy="14" r="1.7"/>
      <circle class="dot" cx="23" cy="14" r="1.7"/>
      <circle class="dot" cx="14" cy="19" r="1.7"/>
      <circle class="dot" cx="20" cy="19" r="1.7"/>
    </template>
    <template v-else>
      <path class="line strong" d="M16 7v18M7 16h18"/>
    </template>
  </svg>
</template>

<style scoped>
.sock-tool-icon{display:block;width:26px;height:26px}.fill{fill:color-mix(in srgb,currentColor 18%,white);stroke:currentColor;stroke-width:1.5}.line{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}.strong{stroke-width:2}.dot,.bead{fill:#fff;stroke:currentColor;stroke-width:1.4}.bead{fill:color-mix(in srgb,currentColor 24%,white)}.stitch{stroke-dasharray:2 2}
</style>
